var player = null; // 楽曲試聴プレイヤー初期化
var videoPlayer = null; // 動画試聴プレイヤー初期化
var playClass = 'js-audition-play item-detail-digital__player-btn--play'; // 試聴再生クラス
var pauseClass = 'js-audition-pause item-detail-digital__player-btn--pause'; // 試聴停止クラス

$(function() {
    /* 試聴実行 */
    var $pageBody = $('body'); // Bodyタグに再生中か判定するクラスを付与するため、取得
    var isPlaying = 'isPlaying'; // 再生中に付与するクラス

    $(document).on('click', '.js-audition-play', async function() { // click()は動的に追加された要素に有効ではないためこの書き方
        var $this = $(this);
        var itemId = $this.data('itemId'); // 販売商品ID
        var primaryContentId = $this.data('primaryContentId'); // リリースプライマリコンテンツID
        var fileType = $this.data('fileType'); // ファイル種別(`Audio` or `Video`)
        var fileSpecClass = $this.data('fileSpecClass'); // ファイルスペック区分
        var trialUrl = await getTrialUrl(itemId, primaryContentId, fileType, fileSpecClass);

        if (trialUrl === '') {
            showDialog('試聴ファイルの取得に失敗しました');
        } else {
            if (fileType === 'Video') {
                if (videoPlayer === null) {
                    videoPlayer = new MediaElementPlayer('moviePlayer', {
                        iconSprite: '/img/mejs-controls.svg',
                        stretching: 'fill'
                    });
                }

                videoPlayer.setSrc(trialUrl);
                $('.js-video-modal').show();
                $('.js-video-modal-overlay').show();

                videoPlayer.play();
            } else {
                if (player === null) {
                    player = new MediaElementPlayer('audioPlayer', {
                        iconSprite: '/img/mejs-controls.svg'
                    });
                }
                // 楽曲試聴コントロールエリアの非表示
                $('.mejs__audio').hide(); // プラグイン内のDOMを操作
                player.setSrc(trialUrl);

                player.play();
            }
            // iOSのブラウザバック時に再生中か判定するため、Bodyタグに再生中クラスを付与
            $pageBody.addClass(isPlaying);

            // 一つ前に再生していた試聴アイコンを初期化
            var $pauseButton = $('.js-audition-pause');
            if ($pauseButton.length > 0) {
                $pauseButton
                    .removeClass(pauseClass)
                    .addClass(playClass);
            }
            $this
                .removeClass(playClass)
                .addClass(pauseClass);

            /*
             * Mac版Safariで再生終了時に処理を行いたい場合、クリックイベントが起きるたびに、
             * 再生終了に合わせて処理を行うイベントハンドラを呼び出す必要があるため、
             * クリックイベント内でその処理を呼び出す
             */
            if (isMacSafari) {
                // 再生終了に合わせて処理を行うイベントハンドラ
                $('#audioPlayer').on('ended', function() {
                    if ($('.js-audition-pause').length > 0) {
                        // iOSのブラウザバック時に再生中か判定するため、Bodyタグに再生中クラスを削除
                        $pageBody.removeClass(isPlaying);

                        $('.js-audition-pause')
                            .removeClass(pauseClass)
                            .addClass(playClass);
                    }

                    // イベントハンドラの重複を防ぐため、イベントハンドラを削除
                    $('#audioPlayer').off('ended');
                });

                /*
                 * イベントハンドラの重複を防ぐため、試聴が停止された場合に、
                 * イベントハンドラを削除する
                 */
                $('.js-audition-pause').on('click', function() {
                    $('#audioPlayer').off('ended');
                    $('.js-audition-pause').off('click');
                });
            }
        }
    });

    /* 試聴停止 */
    $(document).on('click', '.js-audition-pause', function() { // click()は動的に追加された要素に有効ではないためこの書き方
        player.pause();

        // iOSのブラウザバック時に再生中か判定するため、Bodyタグに再生中クラスを削除
        $pageBody.removeClass(isPlaying);

        $(this)
            .removeClass(pauseClass)
            .addClass(playClass);
    });

    /* Mac版Safariではない場合、再生が完了したら停止アイコンを戻す */
    if (!isMacSafari) {
        $('#audioPlayer').on('ended', function() {
            // iOSのブラウザバック時に再生中か判定するため、Bodyタグに再生中クラスを削除
            $pageBody.removeClass(isPlaying);

            if ($('.js-audition-pause').length > 0) {
                $('.js-audition-pause')
                    .removeClass(pauseClass)
                    .addClass(playClass);
            }
        });
    }

    /*
     * iOS向けブラウザバック時に試聴音源を再生したままにしない対応
     * ブラウザバック時に試聴中の楽曲が再生されないように、
     * ページ遷移時に、試聴中の楽曲を停止・アイコンを切り替える
     */
    if (isIos) {
        $(document).on('click', 'body.isPlaying a[href]:not(a[href^="#"])', function(e) {
            e.preventDefault;
            var targetHref = $(this).attr('href');
            // iOSのブラウザバック時に再生中か判定するため、Bodyタグに再生中クラスを削除
            $pageBody.removeClass(isPlaying);

            // 試聴の再生を停止
            player.pause();

            // 一時停止アイコンを再生アイコンに切り替え
            $('.js-audition-pause')
                .removeClass(pauseClass)
                .addClass(playClass);

            window.location.href = targetHref;
        });
    }

    /* 動画試聴停止 */
    $('.js-video-modal-overlay, .js-video-modal-close').on('click', function() {
        // iOSのブラウザバック時に再生中か判定するため、Bodyタグに再生中クラスを削除
        $pageBody.removeClass(isPlaying);

        videoPlayer.pause();

        $('.js-audition-pause')
            .removeClass(pauseClass)
            .addClass(playClass);
        $('.js-video-modal').hide();
        $('.js-video-modal-overlay').hide();
    });
});

/**
 * 試聴URL取得
 *
 * @param {number} itemId 販売商品ID
 * @param {number} primaryContentId リリースプライマリコンテンツID
 * @param {string} fileType ファイル種別(Audio or Video)
 * @param {string} fileSpecClass ファイルスペック区分
 * @returns {Promise<string>} 試聴URL
 */
async function getTrialUrl(itemId, primaryContentId, fileType, fileSpecClass) {
    var trialUrl = '';
    var params = {
        'primaryContentId': primaryContentId,
        'fileType': fileType,
        'fileSpecClass': fileSpecClass
    };

    await $.ajax({
        type: 'GET',
        url: '/api/item/' + itemId + '/trial',
        data: params,
        dataType: 'json',
        cache: false,
    }).done(function(response) {
        if ('url' in response) {
            trialUrl = response.url;
        }
    }).catch(function(e) {
        // 失敗時は空文字返却
    });

    return trialUrl;
}
